import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const LoyaltyInfluencerLogoBlack: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--loyalty-influencer-logo-icon')}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M15.73 4.011c-1.405 0-2.73.695-3.725 1.73C11.008 4.702 9.678 4 8.271 4c-1.408 0-2.737.577-3.731 1.618A5.601 5.601 0 003 9.52c0 1.466.55 2.85 1.547 3.894L11.994 21l7.455-7.563a5.624 5.624 0 001.55-3.908 5.594 5.594 0 00-1.535-3.9c-.997-1.044-2.322-1.618-3.735-1.618z"
        fill="#000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default LoyaltyInfluencerLogoBlack;
